<template>
  <section>
    <div>
      <hr>
      <b-tabs
        v-model="tabIndex"
        small
        content-class="mt-3"
        @activate-tab="loadTabResults"
      >
        <b-tab
          ref="listTab"
          title="List"
        >
          <ResultTable
            @submit-form="submitForm"
            @load-whole-table="loadWholeTable"
            @sort-changed="onSort"
            @exclude-rows="submitExcludeRows"
          />
        </b-tab>
        <b-tab
          title="Reach and Frequency"
          :disabled="!hasSelection"
        >
          <Reach @onSearchReach="searchReach" />
        </b-tab>
        <b-tab
          v-if="config_ShowProgramConsumptionTab"
          title="Consumption Pattern"
          :disabled="!hasSelection"
        >
          <ProgramConsumption ref="programConsumptionComponent" />
        </b-tab>
        <template v-slot:tabs-end>
          <div
            v-if="tabIndex === 0"
            class="sumexportbtnswrapper"
          >
            <b-button
              variant="primary"
              size="sm"
              class="mr-2"
              :disabled="measuresInTable.length === 0"
              @click="showOrHideSumInTable"
            >
              {{ sumVisible ? "Hide summary" : "Show summary" }}
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="exportResult"
            >
              <b-icon icon="arrow-repeat" />
              Export
            </b-button>
          </div>
        </template>
      </b-tabs>
    </div>
    <ConfirmDialog
      :dialog-id="confirmDialogId"
      :dialog-vertical-center="true"
      dialog-title="Adjust your search for Consumption Pattern"
      :dialog-message="tabDialogMessage"
    >
      <template #modal-footer>
        <b-button
          size="sm"
          variant="primary"
          class="px-4"
          @click="closeDialog"
        >
          Ok
        </b-button>
      </template>
    </ConfirmDialog>
  </section>
</template>

<script>
import ResultTable from './ResultTable.vue';
import Reach from './Reach.vue';
import ProgramConsumption from './ProgramConsumption.vue';
import { mapActions } from 'vuex';
import { bus } from '../../../main';
import ConfirmDialog from "@/components/Shared/Dialogs/ConfirmDialog"

import { downloadFile } from '../../../assets/js/api.js';

export default {
  name: 'Result',
  components: {
    ResultTable,
    Reach,
    ProgramConsumption,
    ConfirmDialog,
  },
  props: {
    goToListTab: Boolean
  },
  data() {
    return {
      tabIndex: 0,
      confirmDialogId: "change-tab-dialog",
      tabDialogMessage: ""
    };
  },
  computed: {
    sumVisible() {
      return this.$store.getters[`searchResults/getSumVisible`];
    },
    hasSelection() {
      return this.$store.state.reachApiBody.payload.title_codes.length > 0;
    },
    measuresInTable() {
      return this.$store.getters[`searchResults/getMeasuresInTable`];
    },
    hasExcludedRows() {
      return this.$store.getters[`searchResults/getHasExcludedRows`];
    }
  },
  watch: {
    goToListTab(goToListTab) {
      if(goToListTab){
        this.tabIndex = 0;
        this.$emit('resetGoToListTab');
      }
    }
  },
  mounted() {
    bus.$on('searching', () => {
      if (this.$refs.listTab !== undefined) {
        this.$refs.listTab.activate();
        this.$store.commit('reachApiBody/emptyTitleCodes');
        this.$store.commit('searchResults/unselectAll');
      }
    });
    //get back to listTab when change periodtype
    bus.$on('changePeriod', () => {
      if (this.$refs.listTab !== undefined) {
        this.$refs.listTab.activate();
      }
    });
  },
  methods: {
    ...mapActions(['searchReach']),
    onSort(item) {
      this.$emit('sort-only', item);
    },
    submitForm(item) {
      this.$emit('submit-form', item);
    },
    loadWholeTable(load) {
      this.$emit('load-whole-table', load);
    },
    submitExcludeRows() {
      this.$emit('exclude-rows');
    },
    async loadTabResults(newTabIndex, prevTabIndex, bvEvent) {
      if(newTabIndex === prevTabIndex) return
      if (newTabIndex === 1) {
        this.searchReach()
      }
      if (newTabIndex === 2) {
        if (this.$store.getters['consumptionResults/consumptionResultsQuery'].uniqueDatesInPeriod.length > 7) {
          this.tabDialogMessage = 'You can select a maximum of 7 days as the period to display Consumption Pattern. Choose a new period and press "Run".'
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else if (this.$store.getters['consumptionResults/consumptionResultsQuery'].measures.length < 1) {
          this.tabDialogMessage = 'Select a measure of type reach in target / metric to display Consumption Pattern. Add a reach measure and press "Run".'
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else if (this.$store.getters['consumptionApiBody/consumptionApiBody'].selectedPeriod === "publicationperiod") {
          this.tabDialogMessage = 'Please select "Consumption period" in Period to display Consumption Pattern. Your current selection is "Publication period".'
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else if (this.$store.getters['consumptionApiBody/consumptionApiBody'].title_codes.length > 7) {
          this.tabDialogMessage = "You can select a maximum of 7 programs for Consumption Pattern. Unselect rows in the result list and try again."
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else {
          // Load the consumption tab
          this.tabIndex = newTabIndex
          this.$refs.programConsumptionComponent.onThisTabClick();
          await this.$store.dispatch('consumptionResults/initialize')
        }
      } else {
        this.tabIndex = newTabIndex
      }
    },
    closeDialog() {
      this.$bvModal.hide(this.confirmDialogId)
    },
    async exportResult() {
      try {
        let payload = {...this.$store.state.searchApiBody};
        await downloadFile('QueryData/DownloadExport', payload);
      } catch (error) {
        console.error('Failed to export results:', error);
        // Show error to user
        this.$bvToast.toast('An error occurred while exporting data. Please try again later.', {
          title: 'Export failed',
          variant: 'danger',
          solid: true
        });
      }
    },
    showOrHideSumInTable(){
      this.$store.commit('searchResults/setSumVisible', !this.sumVisible);
    },
  },
};
</script>
